import React from "react";
import { Link } from "react-router-dom";

export default function HeadTab(props) {
  return (
    <>
      <Link to={props.route}>
        <div
          className="mx-auto text-center th-br-12"
          style={{
            opacity: "0.9",
          }}
        >
          <img
            src={props.image}
            alt=""
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.16) 100%)",
            }}
            className="p-2 th-br-12 shadow-sm"
          />
        </div>
        <div
          className="my-2 th-fw-600 th-12 text-center"
          style={{ color: "#FFFFFF", opacity: "0.8" }}
        >
          {props.label}
        </div>
      </Link>
    </>
  );
}
